import { createContext } from 'react';
import { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';

export const BreadcrumbContext = createContext<BreadcrumbsRoute[]>([]);
